import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './css/NoEventsMessage.css';

const NoEventsMessage = ({ 
  message = "No events found. Create your first event to get started!",
  buttonText = "Create New Event",
  navigateTo = '/event-form'
}) => {
  const navigate = useNavigate();

  return (
    <div className="no-events-container">
      <p className="no-events-message">
        {message}
      </p>
      <button 
        className="no-events-button"
        onClick={() => navigate(navigateTo)}
      >
        <FaPlus /> {buttonText}
      </button>
    </div>
  );
};

export default NoEventsMessage;
